import React, { useState, useEffect } from 'react';
import useFetch from "../services/useFetch.js"
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid"
import DeleteIcon from '@mui/icons-material/Delete';
import { Dialog } from '@mui/material';
import PlaceInventoryOrder from "../components/VendorSubComponents/PlaceInventoryOrder.jsx"
import VendorActions from '../components/VendorSubComponents/VendorActions.jsx';
import AddNewVendor from '../components/VendorSubComponents/AddNewVendor.jsx';
import EditVendorInformation from '../components/VendorSubComponents/EditVendorInformation.jsx';
import SnackbarEx from '../components/Helpers/SnackbarEx.jsx';
import DeleteData from '../services/DeleteData.js';
import ConfirmDelete from '../components/Menu/HelperDialogs/ConfirmDelete.jsx';
import UploadedNewIngredient from '../components/Menu/HelperDialogs/UploadedNewIngredient.jsx';
import GetData from '../services/GetData.js';
import PageHeader from '../components/layout/PageHeader.jsx';
import { dataGridSx, quickFilterSx } from '../components/ui/dataGridStyles.js';
import { tokens } from '../theme.js';

export default function Vendor({ reload }) {

    const [reloadData, setReloadData] = useState(false)
    const { data: vendorList, load, error } = useFetch("api/vendors", reloadData)

    const [row, setRow] = useState([])
    const [col, setCol] = useState([])
    const [selIngrIdArr, setSelIngrIdArr] = useState(null)

    const [enableEdit, setEnableEdit] = useState(false)

    const [deleteOpen, setDeleteOpen] = useState(false)
    const [openAddVendor, setOpenAddVendor] = useState(false)
    const [openEditVendor, setOpenEditVendor] = useState(false)
    const [openPlaceOrder, setOpenPlaceOrder] = useState(false)
    const [newIngredients, setNewIngredients] = useState(null)
    const [openNewUploadIngredientInfo, setOpenNewUploadIngredientInfo] = useState(false)

    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false
    })
    const [editIngredient, setEditIngredient] = useState({
        editEnabled: false,
        vendorId: null
    })

    useEffect(() => {
        setData()
    }, [vendorList])


    const actionOptions = async (type) => {
        switch (type) {
            case "addVendor":
                setOpenAddVendor(true)
                break;

            case "placeOrder":
                const { getData: vendors, load, error: vendorErr } = await GetData("api/vendors-email-order", false)
                vendors ? setOpenPlaceOrder(true) : setOpenTestSnack({ color: "warning", message: "No vendor's have email ordering enabled", open: true })
                break;

            case "edit":
                setOpenEditVendor(true)
                break;
        }
    }
    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <div className="me-auto d-flex align-items-center" style={{ gap: 10, flexWrap: 'wrap' }}>
                    <VendorActions selection={actionOptions} editEnable={enableEdit} />
                    <button
                        className={selIngrIdArr?.length ? "delete-bttn" : "delete-dis"}
                        disabled={!selIngrIdArr?.length}
                        onClick={() => setDeleteOpen(true)}
                    >
                        <DeleteIcon sx={{ color: selIngrIdArr?.length ? tokens.danger : "#a39b92", fontSize: 18 }} />
                        <span>Delete</span>
                    </button>
                </div>
                <GridToolbarQuickFilter variant="outlined" size="small" sx={quickFilterSx} />
            </GridToolbarContainer>
        );
    }


    const setData = () => {
        setRow(vendorList?.map((e) =>
        ({
            id: e.vendorId,
            vendorName: e.vendor,
            emailOrdering: e.emailOrdering ?? "false"
        })
        ) ?? [])

        setCol([
            {
                field: 'vendorName', headerName: 'Vendor Name',/* minWidth: '225', maxWidth: '225'*/ flex: 1, editable: true
            },
            {
                field: 'emailOrdering', headerName: 'Email Ordering', /*minWidth: '175', maxWidth: '175'*/ flex: 1
            },
        ]);
    }

    const selectClick = (e) => {

        if (e.length === 1) {
            setEnableEdit(e)
            setSelIngrIdArr(e)
            const findData = vendorList.find((element) => e[0] === element.vendorId)
            setEditIngredient(currVals => ({ ...currVals, vendorId: findData.vendorId }))
        } else if (e.length > 1) {
            setSelIngrIdArr(e)
            setEnableEdit(false)
        } else {
            setEnableEdit(false)
            setSelIngrIdArr(null)
        }
    }

    const closeDialog = (val) => {
        switch (true) {
            case val === "success_edit":
                setOpenEditVendor(false)
                setOpenTestSnack({ color: "success", message: "Vendor successfully updated!", open: true })
                refreshPage()
                break;

            case val === "success_add":
                setOpenAddVendor(false)
                setOpenTestSnack({ color: "success", message: "Vendor successfully added!", open: true })
                refreshPage()
                break;

            case val === "success_order":

                setOpenAddVendor(false)
                setOpenEditVendor(false)
                setOpenPlaceOrder(false)
                setOpenTestSnack({ color: "success", message: "Order successfully sent!", open: true })
                refreshPage()
                break;

            default:
                setOpenAddVendor(false)
                setOpenEditVendor(false)
                setOpenPlaceOrder(false)
                break
        }
    }

    const handleNewUploadIngredients = (newItems) => {
        setOpenNewUploadIngredientInfo(true)
        setNewIngredients(newItems)

    }

    const deleteVendor = async (bool) => {
        setDeleteOpen(false)
        if (bool) {
            const { success: vendorDeleted, error: deleteErr } = await DeleteData(`api/delete-existing-vendor`, { "vendorIds": selIngrIdArr })
            if (vendorDeleted) {
                setEnableEdit(false)
                setSelIngrIdArr(null)
                setEditIngredient(null)
                setOpenTestSnack({ color: "success", message: "Successfully deleted vendor!", open: true })
                refreshPage()
            }
        }
    }
    const refreshPage = () => {
        setReloadData(true)
        setTimeout(() => {
            // Code to be executed after the delay
            setReloadData(false)
        }, 500);
    }

    if (load) {
        return (<div className="container"><CircularProgress /></div>)
    }
    return (
        <div>
            <PageHeader
                title="Vendors"
                subtitle="Add or edit vendors and place inventory orders"
            />

            <div className='row' style={{ width: "100%", padding: '8px 8px 24px' }}>
                <div className='col-12 menu-list dt' >
                    <DataGrid
                        checkboxSelection
                        onRowSelectionModelChange={selectClick}
                        rows={row}
                        columns={col}
                        rowHeight={50}
                        // processRowUpdate={(updatedRow, originalRow) => editCell(updatedRow, originalRow)}
                        onProcessRowUpdateError={(e) => (console.log(e))}
                        slots={{
                            // toolbar: GridToolbar,
                            toolbar: CustomToolbar
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 50,
                                },
                            },
                            sorting: {
                                sortModel: [{ field: 'col6', sort: 'desc' }]
                            }
                        }}
                        sx={{
                            ...dataGridSx,
                            border: 'none',
                        }}
                    />
                </div>
            </div>

            {openAddVendor && (
                <AddNewVendor open={openAddVendor} close={closeDialog} />
            )}

            {openEditVendor && (
                <EditVendorInformation open={openEditVendor} close={closeDialog} vendId={editIngredient} />
            )}

            <Dialog fullScreen open={openPlaceOrder} onClose={closeDialog}>
                <PlaceInventoryOrder close={closeDialog} newIngredients={handleNewUploadIngredients} vendorId={selIngrIdArr ? selIngrIdArr[0] : null} />
            </Dialog>

            <Dialog maxWidth={'sm'} fullWidth open={openNewUploadIngredientInfo} onClose={closeDialog} >
                <UploadedNewIngredient close={closeDialog} ingredients={newIngredients} />
            </Dialog>

            {deleteOpen && <ConfirmDelete deleteItem={deleteVendor} deleteOpen={deleteOpen} />}
            {openTestSnack.open && <SnackbarEx color={openTestSnack.color} message={openTestSnack.message} open={openTestSnack.open}
                close={() => setOpenTestSnack({
                    color: "",
                    message: "",
                    open: false
                })} />}
        </div>
    );
};
